import React      from 'react';
import PropTypes  from 'prop-types';
import { Icon }   from 'components/ui/index';
import classNames from 'classnames';

const CheckIcon = ({ check, className }) => {
  return (
    <Icon
      name={ check ? 'check-circle' : 'uncheck-circle' }
      className={ classNames(className, {
        'text-danger':  !check,
        'text-success': !!check,
      }) }
    />
  );
};

CheckIcon.defaultProps = {
  check:     false,
  className: null,
};

CheckIcon.propTypes = {
  className: PropTypes.string,
  check:     PropTypes.bool,
};

export default CheckIcon;
